var _class, _temp;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import { Vector as olSourceVector, Cluster } from 'ol/source';
import { getCenter } from 'ol/extent';
import { Point } from 'ol/geom';
import { Style, Fill, Stroke, Text, Circle, RegularShape, Icon } from 'ol/style';
import { Vector as olLayerVector } from 'ol/layer';
import React from 'react';
import PropTypes from 'prop-types';
import { ensureMap } from '../hocs/ensureMap';
import { provideMapState } from '../hocs/provideMapState';
import olUtils from '../utils/olUtils';
var defaultFontColor = 'rgb(255, 255, 255)';
var defaultFillColor = 'rgb(238, 153, 0)';
var defaultHoverColor = 'rgb(17, 115, 175)';
var defaultActiveColor = 'rgb(255, 153, 0)';
var defaultOpacity = 100;
var defaultPointRadius = 10;
var defaultStrokeWidth = 2;
var defaultLabelBackgroundFillOpacity = 100;
var defaultFontStrokeOpacity = 100;
var defaultFontOpacity = 100;
var defaultFont = '10px sans-serif';
var LayerStyle = PropTypes.shape({
  pointRadius: PropTypes.number,
  fillColor: PropTypes.string,
  fillOpacity: PropTypes.number,
  strokeColor: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWidth: PropTypes.number,
  fontColor: PropTypes.string,
  fontStrokeColor: PropTypes.string,
  hoverColor: PropTypes.string,
  hoverOpacity: PropTypes.number,
  activeColor: PropTypes.string,
  activeOpacity: PropTypes.number,
  labelProperty: PropTypes.string,
  labelTextTransform: PropTypes.func,
  labelOffsetX: PropTypes.number,
  labelOffsetY: PropTypes.number,
  labelBackgroundFill: PropTypes.string,
  labelBackgroundFillOpacity: PropTypes.number,
  fontOpacity: PropTypes.number,
  font: PropTypes.string,
  labelTextAlign: PropTypes.string,
  labelPadding: PropTypes.array,
  labelRotation: PropTypes.number,
  labelMinZoom: PropTypes.number,
  lineDash: PropTypes.array,
  lineDashOffset: PropTypes.number
});

function hexToRGB(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity / 100 + ')';
}

function createRGB(rgb, opacity) {
  if (rgb.indexOf('rgb') > -1) {
    return rgb;
  }

  return 'rgba(' + rgb.replace(/\s/g, ',') + ', ' + opacity / 100 + ')';
}

function convertColor(value, opacity) {
  if (!value) {
    return;
  }

  if (value.indexOf('#') > -1) {
    return hexToRGB(value, opacity);
  } else {
    return createRGB(value, opacity);
  }
}

function getFeatureStyle(featureStyle) {
  featureStyle = featureStyle || {};
  var _featureStyle = featureStyle,
      pointRadius = _featureStyle.pointRadius,
      fillColor = _featureStyle.fillColor,
      fillOpacity = _featureStyle.fillOpacity,
      strokeColor = _featureStyle.strokeColor,
      strokeOpacity = _featureStyle.strokeOpacity,
      strokeWidth = _featureStyle.strokeWidth,
      fontColor = _featureStyle.fontColor,
      hoverColor = _featureStyle.hoverColor,
      hoverOpacity = _featureStyle.hoverOpacity,
      activeColor = _featureStyle.activeColor,
      activeOpacity = _featureStyle.activeOpacity,
      labelBackgroundFill = _featureStyle.labelBackgroundFill,
      labelBackgroundFillOpacity = _featureStyle.labelBackgroundFillOpacity,
      fontStrokeColor = _featureStyle.fontStrokeColor,
      fontStrokeOpacity = _featureStyle.fontStrokeOpacity,
      fontOpacity = _featureStyle.fontOpacity,
      lineDash = _featureStyle.lineDash,
      lineDashOffset = _featureStyle.lineDashOffset;
  return _extends({}, featureStyle, {
    strokeWidth: strokeWidth || defaultStrokeWidth,
    strokeColor: convertColor(strokeColor || fillColor || defaultFillColor, strokeOpacity || defaultOpacity),
    hoverColor: convertColor(hoverColor || defaultHoverColor, hoverOpacity || defaultOpacity),
    activeColor: convertColor(activeColor || defaultActiveColor, activeOpacity || defaultOpacity),
    fillColor: convertColor(fillColor || defaultFillColor, fillOpacity || defaultOpacity),
    fontColor: convertColor(fontColor || defaultFontColor, fontOpacity || defaultFontOpacity),
    fontStrokeColor: convertColor(fontStrokeColor, fontStrokeOpacity || defaultFontStrokeOpacity),
    pointRadius: pointRadius || defaultPointRadius,
    labelBackgroundFill: convertColor(labelBackgroundFill, labelBackgroundFillOpacity || defaultLabelBackgroundFillOpacity),
    font: featureStyle.font || defaultFont
  });
}

export var VectorLayer = (_temp = _class = function (_React$Component) {
  _inherits(VectorLayer, _React$Component);

  function VectorLayer() {
    _classCallCheck(this, VectorLayer);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  VectorLayer.prototype.componentDidMount = function componentDidMount() {
    this.checkProps(this.props);
  };

  VectorLayer.prototype.componentDidUpdate = function componentDidUpdate() {
    this.checkProps(this.props);
  };

  VectorLayer.prototype.getLineImageImageStyle = function getLineImageImageStyle(image, rotation) {
    switch (image.type) {
      case 'icon':
        return new Icon({
          src: image.src,
          anchor: image.anchor || [0.5, 0.5],
          rotateWithView: true,
          rotation: image.rotate ? -rotation : 0
        });

      case 'regular':
        return new RegularShape({
          points: image.points,
          angle: image.angle,
          stroke: image.strokeColor && new Stroke({
            color: convertColor(image.strokeColor, image.strokeOpacity || 100),
            width: image.strokeWidth
          }),
          fill: image.fillColor && new Fill({
            color: convertColor(image.fillColor, image.fillOpacity || 100)
          }),
          radius: image.pointRadius,
          rotateWithView: true,
          rotation: image.rotate ? -rotation : 0
        });

      case 'circle':
        return new Circle({
          stroke: image.strokeColor && new Stroke({
            color: convertColor(image.strokeColor, image.strokeOpacity || 100),
            width: image.strokeWidth
          }),
          fill: image.fillColor && new Fill({
            color: convertColor(image.fillColor, image.fillOpacity || 100)
          }),
          radius: image.pointRadius
        });
    }
  };

  VectorLayer.prototype.getLineImageStyle = function getLineImageStyle(image, zIndex, start, end) {
    var dx = start[0] - end[0];
    var dy = start[1] - end[1];
    var rotation = Math.atan2(dy, dx);
    return new Style({
      geometry: new Point(start),
      image: this.getLineImageImageStyle(image, rotation),
      zIndex: zIndex
    });
  };

  VectorLayer.prototype.appendLineImageStyles = function appendLineImageStyles(startImage, endImage, zIndex, geometry, styles) {
    var _this2 = this;

    var first = true;
    var last = null;
    geometry.forEachSegment(function (start, end) {
      if (startImage && first) {
        styles.push(_this2.getLineImageStyle(startImage, zIndex, start, end));
      }

      first = false;
      last = {
        start: [].concat(start),
        end: [].concat(end)
      };
    });

    if (endImage && last) {
      styles.push(this.getLineImageStyle(endImage, zIndex, last.end, last.start));
    }
  };

  VectorLayer.prototype.checkProps = function checkProps(props) {
    var _this3 = this;

    var map = props.map,
        layerName = props.layerName,
        featureStyle = props.featureStyle,
        minZoom = props.minZoom,
        maxZoom = props.maxZoom,
        selectable = props.selectable,
        clusterThreshold = props.clusterThreshold,
        useActiveStyle = props.useActiveStyle,
        useHoverStyle = props.useHoverStyle,
        getResolution = props.getResolution;

    if (layerName !== this.props.layerName && map._vectorLayers && map._vectorLayers[this.props.layerName]) {
      map._vectorLayers[this.props.layerName].layer.setVisible(false);
    }

    if (map._vectorLayers && map._vectorLayers[layerName]) {
      this.updateFeatures(props.features, layerName);

      map._vectorLayers[layerName].layer.setVisible(true);

      return;
    }

    featureStyle = getFeatureStyle(featureStyle);
    map._vectorLayers = map._vectorLayers || {}; // Create layer, add to map

    var layerSource = new olSourceVector({});
    var layer = void 0;
    this.updateFeatures(props.features, layerName);

    if (clusterThreshold) {
      var clusterSource = new Cluster({
        distance: clusterThreshold,
        source: layerSource,
        geometryFunction: function geometryFunction(feature) {
          var extent = feature.getGeometry().getExtent();
          var center = getCenter(extent);
          return new Point(center);
        }
      });
      layer = new olLayerVector({
        source: clusterSource,
        minResolution: maxZoom && getResolution(maxZoom),
        maxResolution: minZoom && getResolution(minZoom),
        selectable: selectable,
        style: function style(cluster) {
          var features = cluster.get('features');
          var size = features.length;
          var hover = features.some(function (f) {
            return f.get('hover');
          }) && !!useHoverStyle;
          var active = features.some(function (f) {
            return f.get('active');
          }) && !!useActiveStyle;
          var imageStyle = {
            radius: featureStyle.pointRadius + (size < featureStyle.pointRadius ? size : featureStyle.pointRadius),
            fill: new Fill({
              color: active ? featureStyle.activeColor : hover ? featureStyle.hoverColor : featureStyle.fillColor
            }),
            stroke: new Stroke({
              width: featureStyle.strokeWidth,
              color: active ? featureStyle.activeColor : hover ? featureStyle.hoverColor : featureStyle.strokeColor
            })
          };
          return new Style({
            image: featureStyle.regularShapePoints ? new RegularShape(_extends({}, imageStyle, {
              points: featureStyle.regularShapePoints,
              angle: featureStyle.regularShapeAngle || 0
            })) : new Circle(imageStyle),
            text: new Text({
              text: size > 1 ? size.toString() : '',
              fill: new Fill({
                color: featureStyle.fontColor
              }),
              font: featureStyle.font,
              textAlign: featureStyle.labelTextAlign && featureStyle.labelTextAlign,
              padding: featureStyle.labelPadding && featureStyle.labelPadding,
              rotation: featureStyle.labelRotation && featureStyle.labelRotation
            }),
            zIndex: active ? 10 : hover ? 9 : 1
          });
        }
      });
    } else {
      layer = new olLayerVector({
        source: layerSource,
        minResolution: maxZoom && getResolution(maxZoom),
        maxResolution: minZoom && getResolution(minZoom),
        selectable: selectable,
        style: function style(feature, resolution) {
          var styles = [];
          var geometry = feature.getGeometry();
          var hover = feature.get('hover') && !!useHoverStyle;
          var active = feature.get('active') && !!useActiveStyle;
          var styleProps = {
            fill: new Fill({
              color: active ? featureStyle.activeColor : hover ? featureStyle.hoverColor : featureStyle.fillColor
            }),
            stroke: new Stroke({
              width: featureStyle.strokeWidth,
              lineDash: featureStyle.lineDash,
              lineDashOffset: featureStyle.lineDashOffset,
              color: active ? featureStyle.activeColor : hover ? featureStyle.hoverColor : featureStyle.strokeColor
            }),
            text: featureStyle.labelProperty && (!featureStyle.labelMinZoom || resolution <= getResolution(featureStyle.labelMinZoom)) && new Text({
              text: (featureStyle.labelTextTransform || function (t) {
                return t;
              })(feature.get(featureStyle.labelProperty)),
              fill: new Fill({
                color: featureStyle.fontColor
              }),
              stroke: featureStyle.fontStrokeColor && new Stroke({
                color: featureStyle.fontStrokeColor
              }),
              offsetX: featureStyle.labelOffsetX,
              offsetY: featureStyle.labelOffsetY,
              backgroundFill: featureStyle.labelBackgroundFill && new Fill({
                color: featureStyle.labelBackgroundFill
              }),
              textAlign: featureStyle.labelTextAlign && featureStyle.labelTextAlign,
              font: featureStyle.font,
              padding: featureStyle.labelPadding && featureStyle.labelPadding,
              rotation: featureStyle.labelRotation && featureStyle.labelRotation
            }),
            zIndex: active ? 10 : hover ? 9 : 1
          };

          if (feature.getGeometry().getType() === 'Point' || feature.getGeometry().getType() === 'MultiPoint') {
            var pointStyle = new Style({
              image: featureStyle.regularShapePoints ? new RegularShape({
                points: featureStyle.regularShapePoints,
                angle: featureStyle.regularShapeAngle || 0,
                radius: featureStyle.pointRadius,
                fill: styleProps.fill,
                stroke: styleProps.stroke
              }) : new Circle({
                radius: featureStyle.pointRadius,
                fill: styleProps.fill,
                stroke: styleProps.stroke
              }),
              text: styleProps.text
            }); // Overrides pointStyle if there is an image style defined

            if (featureStyle.image) {
              pointStyle = new Style({
                image: olUtils.createOlIcon(featureStyle.image),
                text: styleProps.text
              });
            }

            return pointStyle;
          }

          styles.push(new Style(styleProps));

          if (featureStyle.startImage || featureStyle.endImage) {
            if (geometry.getType() === 'LineString') {
              _this3.appendLineImageStyles(featureStyle.startImage, featureStyle.endImage, styleProps.zIndex, geometry, styles);
            } else if (geometry.getType() === 'MultiLineString') {
              geometry.getLineStrings().forEach(function (line) {
                _this3.appendLineImageStyles(featureStyle.startImage, featureStyle.endImage, styleProps.zIndex, line, styles);
              });
            }
          }

          return styles;
        }
      });
    }

    map._vectorLayers[layerName] = {
      layer: layer,
      layerSource: layerSource
    };
    this.mountLayer(layerName);
  };

  VectorLayer.prototype.mountLayer = function mountLayer(layerName) {
    var map = this.props.map;

    if (!map) {
      setTimeout(this.mountLayer.bind(this, layerName), 200);
      return;
    }

    try {
      map.addLayer(map._vectorLayers[layerName].layer);
    } catch (ex) {} // Adding a layer twice can happen due to above delay


    this.updateFeatures(this.props.features, layerName);
  };

  VectorLayer.prototype.updateFeatures = function updateFeatures(features, layerName) {
    var map = this.props.map;

    var _ref = map._vectorLayers[layerName] || {},
        layerSource = _ref.layerSource;

    if (layerSource) {
      layerSource.clear();
      layerSource.addFeatures(features);
    }
  };

  VectorLayer.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props = this.props,
        map = _props.map,
        layerName = _props.layerName;

    map._vectorLayers[layerName].layer.setVisible(false);
  };

  VectorLayer.prototype.render = function render() {
    return React.createElement('span', null);
  };

  VectorLayer.prototype.zoomToExtent = function zoomToExtent() {
    var _props2 = this.props,
        map = _props2.map,
        fitViewAndZoom = _props2.fitViewAndZoom,
        maxZoom = _props2.maxZoom;
    fitViewAndZoom(map._vectorLayers[this.id].layerSource.getExtent(), maxZoom);
  };

  return VectorLayer;
}(React.Component), _class.defaultProps = {
  selectable: true
}, _temp);
VectorLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  features: PropTypes.array,
  layerName: PropTypes.string,
  featureStyle: LayerStyle,
  minZoom: PropTypes.number,
  maxZoom: PropTypes.number,
  clusterThreshold: PropTypes.number,
  useActiveStyle: PropTypes.bool,
  useHoverStyle: PropTypes.bool,
  selectable: PropTypes.bool,
  map: PropTypes.object,
  getResolution: PropTypes.func,
  fitViewAndZoom: PropTypes.func.isRequired
} : {};
export default provideMapState(ensureMap(VectorLayer));